import './Button.scss';

const Button = ({ action, disabled, text, className, type, icon, name, component, styles, badge, a11y }) => (
  <button
    type={type ?? 'button'}
    disabled={disabled}
    onClick={action}
    className={`Button ${className}`}
    name={name}
    style={styles}
  >
    {a11y && <span className="sr-only">{a11y}</span>}
    {icon && <img alt=" " className="Button menu_icon" src={icon} />}
    {text && <span className="Button_text">{text}</span>}
    {badge && <span className='Button_menu_badge'>{badge}</span>}
    {component}
  </button>
);

export default Button;
